import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import PacatoYService from '../rest/pacatoY'
import AuthService from '../rest/auth'
import router from '../../router'

Vue.use(Vuex)

let pacatoyService = null;

export const store = new Vuex.Store({
   
    state: {
        
        configs: [],
        loading: false,
        token_id_settimeout:null,
        user:{
            token:null, //{access_token,token_type,expires_in},
            data:{}
        }
    },
    plugins: [createPersistedState()],
    getters:{
        token: state=>{
            return state.user.token? state.user.token.access_token : null;
        },
        user: state=>{
            return state.user.data;
        },
        is_loggedin:state=>{
            return state.user.token!==null;
        },
        configs:state=>{
            return state.configs;
        },
        loading: state=>{
            return state.loading;
        },        
        composer: state=>{
            return state.user.data.composers[0];
        },
        publishers:state=>{
            return state.publishers;
        }
    },
    mutations:{
       
        /**
         * Configs
         * @param {*} state 
         * @param {*} configs 
         */
        _configs(state, configs){
            state.configs = configs;
        }, 
        /**
         * Publisher Update
         * @param {Vuex.Store} state 
         */
        _publishers_update(state, publishers) {
            //@todo verificar se houve alteração antes de recarregar
            state.publishers = publishers;

        },      
         /**
         * Muda o status de carregando da página
         * @param {*} state 
         */
        _loading(state, loading = null) {
            
            state.loading = loading!= null? loading : !state.loading;
        },
        /**
         * Controla o estado do token
         * @param {*} state 
         * @param {*} val 
         */
        token(state, val = null){            
            state.user.token = val;
        },
        /**
         * Controla o estado usuário
         * @param {*} state 
         * @param {*} data 
         */
        user(state, data={}){
            state.user.data = data;
        }
    },
    actions:{
        user_unload(context){
            clearTimeout(context.state.token_id_settimeout);
            context.state.token_id_settimeout = null;
            this.commit('user', null);
            this.commit('token', null);  
        },
        user_authenticate_refresh(context, force=false){
          

            if(force){
                clearTimeout(context.state.token_id_settimeout);
                context.state.token_id_settimeout = null
            }

            if(context.getters.token==null){
                return router.push({name:'login'});
            }
            if(context.state.token_id_settimeout != null){
                return;
            }
           
            
            clearTimeout(context.state.token_id_settimeout);
            
            context.state.token_id_settimeout = setTimeout(function(){
                var auth = AuthService.build();
                auth.refresh_token().then(e =>{                    
                    clearTimeout(context.state.token_id_settimeout);
                    context.state.token_id_settimeout = null;
                    context.dispatch("user_authenticate_data", e)
                    
                }).catch(()=>{
                    //enviar para o login
                });
            }, context.state.user.token.expires_in-1000) //10 segundos antes de expirar chama o refresh
        },
        /**
         * Chamado quando o usuário é logado
         * @param {*} context 
         * @param {*} data 
         */
        user_authenticate_data (context, data){
            
            if(data.token && data.user){
              this.commit('user', data.user);
              this.commit('token', data.token);   
              context.dispatch("pos_login");
              context.dispatch("user_authenticate_refresh");
            }
          },
        /**
         * Controla o estado do loading full que cobre toda as página
         * @param {*} context 
         */
        loading(context, val = true){
            context.commit("_loading", val);
        },
        load_configs(context){
            pacatoyService = PacatoYService.build();
            pacatoyService.configs().then(e =>{                
                context.commit("_configs", e.items);
                context.commit("_loading", false);
            })       
        },
        publishers_update(context, publishers = null){
            /*return new Promise( (resolve, reject) =>{
                publisherService = PublisherService.build();
                publisherService.getAll().then(
                        response => {
                           
                            if (Array.isArray(response.items)) {
                                context.commit("_publishers_update", response.items);
                                context.commit("loading", false);
                                resolve();
                            }
                            else{
                                reject(response);
                            }
                        }
                    );


            })*/
        },
        /**
         * Chamado após o login para carregar as informações que não se alteram ou
         * se alteram pouco
         * @param {*} context 
         */
        pos_login(context){
            
            context.dispatch("load_configs");   
            //context.dispatch("obras_update");
            //context.dispatch("publishers_update");
            
        }
    }
});
